import api from '@/client/axiosInstance';
import axios from 'axios';

export interface AnalyticsApiKey {
  id: string;
  name: string;
  keyPrefix: string;
  isActive: boolean;
  lastUsedAt: string | null;
  revokedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

// Returned only by the create endpoint — the plaintext key is shown once.
export interface CreatedAnalyticsApiKey extends AnalyticsApiKey {
  key: string;
}

const handleError = (error: unknown, message: string): never => {
  if (axios.isAxiosError(error)) {
    throw new Error(
      `${message}: ${error.response?.data?.message || error.message}`,
    );
  }
  throw new Error(`${message}: Unknown error occurred`);
};

export const getApiKeys = async (): Promise<AnalyticsApiKey[]> => {
  try {
    const response = await api.get('admin/api-keys');
    return response.data ?? [];
  } catch (error) {
    return handleError(error, 'Error fetching API keys');
  }
};

export const createApiKey = async (
  name: string,
): Promise<CreatedAnalyticsApiKey> => {
  try {
    const response = await api.post('admin/api-keys', { name });
    return response.data;
  } catch (error) {
    return handleError(error, 'Error creating API key');
  }
};

export const revokeApiKey = async (id: string) => {
  try {
    const response = await api.patch(`admin/api-keys/${id}/revoke`);
    return response.data;
  } catch (error) {
    return handleError(error, 'Error revoking API key');
  }
};

export const deleteApiKey = async (id: string) => {
  try {
    const response = await api.delete(`admin/api-keys/${id}`);
    return response.data;
  } catch (error) {
    return handleError(error, 'Error deleting API key');
  }
};
